// eslint-disable-next-line jira/filename-case
import React, { memo } from 'react';
import { SidebarBoundary } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/ui/sidebar-boundary/index.tsx';
import { SkeletonNavMenuItems } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/ui/skeleton-nav-menu-items/main.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { JsmProjectMenuProps } from './ui/project-menu/JsmProjectMenu.tsx';

const Skeleton = () => <SkeletonNavMenuItems count={1} />;

const LazySidebarContentWrapper = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-jira-navigation-apps-sidebar-nav4-sidebar-jsm-project-menu-wrapper" */ './ui/project-menu/JsmProjectMenuWrapper.tsx'
		).then(({ JsmProjectMenuWrapper }) => JsmProjectMenuWrapper),
	{
		includeInShellOnlySsrBundle: true,
		entryFsSsrLiftImportToModule: true,
	},
);

export const AsyncJsmProjectMenu: React.MemoExoticComponent<
	({ projectData, menuItemButtonRef }: JsmProjectMenuProps) => React.JSX.Element
> = memo(
	({ projectData, menuItemButtonRef }: JsmProjectMenuProps): React.JSX.Element => (
		<SidebarBoundary
			id="nav4.sidebar.jsm-project-menu"
			packageName="jiraNavigationAppsSidebarNav4JsmProjectMenu"
			teamName="jsm-grape-soju"
			ufoName="nav4.sidebar.jsm-project-menu"
		>
			<Placeholder name="nav4.sidebar.jsm-project-menu.loading-lazy" fallback={<Skeleton />}>
				<LazySidebarContentWrapper
					projectData={projectData}
					menuItemButtonRef={menuItemButtonRef}
				/>
			</Placeholder>
		</SidebarBoundary>
	),
);
